<template>
  <div>
    <b-container fluid>
      <h1>コマンド設計</h1>
      <button
        class="btn btn-outline-secondary"
        @click="confirmStart = !confirmStart"
      >スタート</button>
      <router-link
        class="btn btn-outline-secondary"
        to="/"
      >戻る</router-link>
      <div v-for="process in processes" :key="process.name">
        <b-row align-v="center">
          <b-col>
            <b-spinner
              v-if="process.status === 0"
              variant="secondary"
              type="grow"
            ></b-spinner>
            <b-spinner
            v-if="process.status === 1"
              variant="success"
            ></b-spinner>
            <v-icon
              v-if="process.status === 2"
              size="40"
              class="done_circle"
            >mdi-check-circle-outline</v-icon>
            <span class="left_space">{{ process.translate }}</span>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <CommandList />
    <b-modal
      v-model="confirmStart"
      hide-footer
    >
      <b-row align-h="center">
        <p>作成してよろしいですか。</p>
      </b-row>
      <b-row align-h="around" >
        <button
          class="btn btn-outline-secondary"
          @click="startDesign"
        >はい</button>
        <button
          class="btn btn-outline-danger"
          @click="confirmStart = !confirmStart"
        >いいえ</button>
      </b-row>
    </b-modal>
    <b-modal
      v-model="cannotDesign"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-row align-h="center">
        <p>属性作成後に再度実行してください</p>
      </b-row>
      <b-row align-h="center">
        <button
          class="btn btn-outline-secondary"
          @click="pageBack"
        >OK</button>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
import { mapState } from 'vuex'
import CommandList from '../list/Commands'
export default {
  name: 'ProgressCommand',
  components: {
    CommandList
  },
  data () {
    return {
      status: '',
      confirmStart: false,
      cannotDesign: false,
      canDisplay: false,
      processes: [
        {
          name: 'CommandDesignAccepted',
          translate: 'コマンド設計開始',
          status: 0
        },
        {
          name: 'PreprocessingCommandDesign',
          translate: 'コマンド設計前処理',
          status: 0
        },
        {
          name: 'CommandDesign',
          translate: 'コマンド設計',
          status: 0
        },
        {
          name: 'CommandDesignByProtocol',
          translate: '通信別コマンド',
          status: 0
        },
        {
          name: 'CommandDesignCompletion',
          translate: 'コマンド設計終了',
          status: 0
        }
      ],
      latest_done: '',
      eachStatus: ['waiting', 'working', 'completed']
    }
  },
  methods: {
    checkProgress () {
      let lastestDoneIndex = 0
      this.processes.forEach(function (elm, index) {
        if (elm.name === this.latest_done) {
          lastestDoneIndex = index
        }
      }.bind(this))
      this.processes.forEach(function (elm, index) {
        if (index <= lastestDoneIndex) {
          elm.status = 2
        } else if (index === lastestDoneIndex + 1) {
          elm.status = 1
        } else {
          elm.status = 0
        }
      })
    },
    async startDesign () {
      this.confirmStart = false
      const result = await API.graphql(graphqlOperation(`
        mutation createCommand {
          createCommandDesign(
            version: "${this.version}"
            job_id: "${this.job_id}"
          ){
            job_id
            status
          }
        }
      `))
      this.$log.debug(result)
      this.job_id = result.data.createCommandDesign.job_id
      this.$store.commit('updateJobId', result.data.createCommandDesign.job_id)
      await API.graphql(graphqlOperation(`
        subscription updateJobSubscription {
          onUpdateCommandDesign(
            job_id:"${this.job_id}"
          ){
            status
            job_id
          }
        }
      `)
      ).subscribe({
        next: function (eventData) {
          this.$log.debug('=== Event Data ===', eventData)
          this.latest_done = eventData.value.data.onUpdateCommandDesign.status
        }.bind(this)
      })
    },
    pageBack () {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState(['version', 'job_id', 'completed_job'])
  },
  async mounted () {
    const response = await API.graphql(graphqlOperation(`
      query getLatestDesign{
        getLatestDesign(version: "${this.version}"){
          job_id
          version
          status
          property_design{
            items {
              id
            }
          }
          attribute_design {
            items {
              id
            }
          }
          command_design {
            items{
              id
            }
          }
          command_by_protocol {
            items{
              id
            }
          }
          command_by_sender {
            items {
              id
            }
          }
        }
      }
    `))
    this.$log.debug(response)
    if (response.data.getLatestDesign.attribute_design.items.length === 0) {
      this.cannotDesign = true
    }
    if (response.data.getLatestDesign.command_design.items.length > 0) {
      this.canDisplay = true
    }
  },
  watch: {
    latest_done: function (newValue) {
      this.checkProgress()
      if (newValue === 'CommandDesignCompletion') {
        this.$store.commit('updateCompletedJob', 'command')
      }
    }
  }
}
</script>
<style>
  /* .done_circle {
    margin-bottom: 0.7rem;
  } */
  .left_space{
    margin-left: 1rem;
  }
</style>
